export default __webpack_public_path__ + "static/americas-sagebrush-navy-df737208aaf123b0cc44aa2bb6da9cd7.png";